import { useState } from "react";

// ── VEHICLE DATA ──────────────────────────────────────────────────────────────
const VEHICLE_DATA = {
  "Acura":         ["ILX","Integra","MDX","RDX","TLX","ZDX"],
  "Audi":          ["A3","A4","A5","A6","A7","A8","e-tron","Q3","Q5","Q7","Q8","TT"],
  "BMW":           ["2 Series","3 Series","4 Series","5 Series","7 Series","8 Series","i4","iX","X1","X2","X3","X4","X5","X6","X7","Z4"],
  "Buick":         ["Enclave","Encore","Encore GX","Envision"],
  "Cadillac":      ["CT4","CT5","Escalade","LYRIQ","XT4","XT5","XT6"],
  "Chevrolet":     ["Blazer","Bolt EV","Colorado","Corvette","Equinox","Malibu","Silverado 1500","Silverado 2500HD","Suburban","Tahoe","Traverse","Trax"],
  "Chrysler":      ["300","Pacifica","Voyager"],
  "Dodge":         ["Challenger","Charger","Durango","Hornet"],
  "Ford":          ["Bronco","Bronco Sport","Edge","Escape","Explorer","F-150","F-250","F-350","Maverick","Mustang","Mustang Mach-E","Ranger","Transit"],
  "GMC":           ["Acadia","Canyon","Sierra 1500","Sierra 2500HD","Terrain","Yukon"],
  "Honda":         ["Accord","Civic","CR-V","HR-V","Odyssey","Passport","Pilot","Ridgeline"],
  "Hyundai":       ["Elantra","IONIQ 5","IONIQ 6","Kona","Palisade","Santa Fe","Sonata","Tucson","Venue"],
  "Infiniti":      ["Q50","Q60","QX50","QX55","QX60","QX80"],
  "Jeep":          ["Cherokee","Compass","Gladiator","Grand Cherokee","Renegade","Wrangler"],
  "Kia":           ["Carnival","EV6","Forte","K5","Niro","Seltos","Sorento","Soul","Sportage","Telluride"],
  "Land Rover":    ["Defender","Discovery","Discovery Sport","Range Rover","Range Rover Evoque","Range Rover Sport"],
  "Lexus":         ["ES","GS","GX","IS","LC","LS","LX","NX","RX","UX"],
  "Lincoln":       ["Aviator","Corsair","Nautilus","Navigator"],
  "Mazda":         ["CX-30","CX-5","CX-50","CX-90","Mazda3","Mazda6","MX-5 Miata"],
  "Mercedes-Benz": ["A-Class","C-Class","CLA","E-Class","EQS","G-Class","GLA","GLC","GLE","GLS","S-Class"],
  "Mitsubishi":    ["Eclipse Cross","Outlander","Outlander Sport"],
  "Nissan":        ["Altima","Armada","Frontier","Kicks","Leaf","Maxima","Murano","Pathfinder","Rogue","Sentra","Titan","Versa"],
  "Ram":           ["1500","2500","3500","ProMaster"],
  "Rivian":        ["R1S","R1T"],
  "Subaru":        ["Ascent","BRZ","Crosstrek","Forester","Impreza","Legacy","Outback","Solterra","WRX"],
  "Tesla":         ["Cybertruck","Model 3","Model S","Model X","Model Y"],
  "Toyota":        ["4Runner","Camry","Corolla","Crown","GR86","Highlander","Land Cruiser","Prius","RAV4","Sequoia","Sienna","Tacoma","Tundra","Venza","bZ4X"],
  "Volkswagen":    ["Atlas","Golf","ID.4","Jetta","Passat","Taos","Tiguan"],
  "Volvo":         ["C40","S60","S90","V60","XC40","XC60","XC90"],
};

const VEHICLE_MAKES = Object.keys(VEHICLE_DATA).sort();
const VEHICLE_YEARS = Array.from({ length: 31 }, (_, i) => String(2025 - i));

// ── COMMON PARTS CATEGORIES ───────────────────────────────────────────────────
const PARTS_CATEGORIES = [
  {
    category: "Engine",
    icon: "🛢️",
    parts: ["Oil Filter","Air Filter","Spark Plugs","Ignition Coil","Fuel Filter","PCV Valve","Thermostat","Water Pump","Timing Belt","Timing Chain","Serpentine Belt","Engine Mount"],
  },
  {
    category: "Brakes",
    icon: "🛑",
    parts: ["Brake Pads","Brake Rotors","Brake Calipers","Brake Drums","Brake Shoes","Brake Lines","Brake Master Cylinder","ABS Sensor"],
  },
  {
    category: "Suspension & Steering",
    icon: "🔩",
    parts: ["Shock Absorbers","Struts","Control Arms","Tie Rod Ends","Ball Joints","Wheel Bearings","Sway Bar Links","CV Axle","CV Boot"],
  },
  {
    category: "Tires & Wheels",
    icon: "🔧",
    parts: ["TPMS Sensor","Tire Valve Stem","Lug Nuts","Hub Cap","Wheel Stud","Spare Tire"],
  },
  {
    category: "Electrical",
    icon: "⚡",
    parts: ["Car Battery","Alternator","Starter Motor","Fuse","Relay","Headlight Bulb","Tail Light Bulb","Turn Signal Bulb","Wiper Blades","Wiper Motor"],
  },
  {
    category: "Transmission & Drivetrain",
    icon: "⚙️",
    parts: ["Transmission Filter","Transmission Fluid","Clutch Kit","Flywheel","U-Joint","Differential Fluid"],
  },
  {
    category: "Cooling & AC",
    icon: "❄️",
    parts: ["Radiator","Coolant/Antifreeze","Radiator Hose","AC Compressor","AC Condenser","Cabin Air Filter","Heater Core"],
  },
  {
    category: "Body & Exterior",
    icon: "🚗",
    parts: ["Headlight Assembly","Tail Light Assembly","Side Mirror","Hood Strut","Windshield","Door Handle","Bumper Cover"],
  },
];

// ── STORES ────────────────────────────────────────────────────────────────────
const STORES = [
  {
    name:    "RockAuto",
    icon:    "R",
    color:   "#cc0000",
    badge:   "Best for OEM & aftermarket",
    note:    "Lowest prices, ships only",
    buildUrl: (year, make, model, part) =>
      `https://www.rockauto.com/en/catalog/${encodeURIComponent(make.toLowerCase())},${year}/`,
  },
  {
    name:    "Amazon Auto",
    icon:    "A",
    color:   "#ff9900",
    badge:   "Prime eligible",
    note:    "Fast shipping, wide selection",
    buildUrl: (year, make, model, part) =>
      `https://www.amazon.com/s?k=${encodeURIComponent(`${year} ${make} ${model} ${part}`)}&rh=n%3A15684181&tag=mioprice-20`,
  },
  {
    name:    "AutoZone",
    icon:    "Z",
    color:   "#e4000f",
    badge:   "In-store pickup",
    note:    "Pick up today at local store",
    buildUrl: (year, make, model, part) =>
      `https://www.autozone.com/searchresult?searchText=${encodeURIComponent(`${year} ${make} ${model} ${part}`)}`,
  },
  {
    name:    "O'Reilly Auto",
    icon:    "O",
    color:   "#00843d",
    badge:   "In-store pickup",
    note:    "Same-day pickup available",
    buildUrl: (year, make, model, part) =>
      `https://www.oreillyauto.com/search?q=${encodeURIComponent(`${year} ${make} ${model} ${part}`)}`,
  },
  {
    name:    "Advance Auto",
    icon:    "V",
    color:   "#e4000f",
    badge:   "Frequent sales",
    note:    "Regular discount codes available",
    buildUrl: (year, make, model, part) =>
      `https://shop.advanceautoparts.com/find/search.htm?searchTerm=${encodeURIComponent(`${year} ${make} ${model} ${part}`)}`,
  },
  {
    name:    "Walmart Auto",
    icon:    "W",
    color:   "#0071ce",
    badge:   "Budget friendly",
    note:    "Pickup or delivery",
    buildUrl: (year, make, model, part) =>
      `https://www.walmart.com/search?q=${encodeURIComponent(`${year} ${make} ${model} ${part}`)}&cat_id=91083`,
  },
  {
    name:    "eBay Motors",
    icon:    "E",
    color:   "#e53238",
    badge:   "OEM & used parts",
    note:    "Best for rare or OEM parts",
    buildUrl: (year, make, model, part) =>
      `https://www.ebay.com/sch/i.html?_nkw=${encodeURIComponent(`${year} ${make} ${model} ${part}`)}&_sacat=6030`,
  },
  {
    name:    "Costco Auto",
    icon:    "C",
    color:   "#005daa",
    badge:   "Member pricing",
    note:    "Tires & batteries — members only",
    buildUrl: (year, make, model, part) =>
      `https://www.costco.com/s?keyword=${encodeURIComponent(`${year} ${make} ${model} ${part}`)}`,
  },
];

// ── AI PRICE ESTIMATOR ────────────────────────────────────────────────────────
async function estimatePrices(year, make, model, part) {
  const prompt = `Return ONLY raw JSON estimating prices for "${part}" for a ${year} ${make} ${model} across these stores.

Schema: {"estimates":[{"store":"","price_low":0,"price_high":0,"oem_price":0,"aftermarket_price":0,"note":""}]}

Include estimates for: RockAuto, Amazon Auto, AutoZone, O'Reilly Auto, Advance Auto, Walmart Auto, eBay Motors
Rules:
- Realistic price ranges for ${year} ${make} ${model} ${part}
- oem_price: OEM/factory part price
- aftermarket_price: quality aftermarket price (Bosch, Denso, Monroe, etc.)
- price_low/high: typical price range at that store
- note: e.g. "OEM Bosch available", "Wide range, check fitment", "Free in-store pickup"
- Prices in USD, no $ sign`;

  const resp = await fetch("/api/anthropic", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      model: "claude-haiku-4-5-20251001",
      max_tokens: 2000,
      messages: [{ role: "user", content: prompt }],
    }),
  });
  if (!resp.ok) throw new Error(`API error ${resp.status}`);
  const data = await resp.json();
  const text = data.content?.find(b => b.type === "text")?.text || "";
  const f = text.indexOf("{"), l = text.lastIndexOf("}");
  if (f === -1) return null;
  return JSON.parse(text.slice(f, l + 1));
}

// ── HELPERS ───────────────────────────────────────────────────────────────────
const inp = { width: "100%", padding: "10px 12px", borderRadius: 10, border: "1.5px solid #e5e7eb", fontSize: 14, outline: "none", boxSizing: "border-box", background: "#fff" };
const lbl = { fontSize: 11, fontWeight: 600, color: "#6b7280", marginBottom: 4, display: "block", textTransform: "uppercase", letterSpacing: 0.5 };
const fld = { display: "flex", flexDirection: "column" };

// ── STORE ROW ─────────────────────────────────────────────────────────────────
function StoreRow({ store, year, make, model, part, estimate, isBest }) {
  const url = store.buildUrl(year, make, model, part);
  const priceStr = estimate
    ? estimate.price_low === estimate.price_high
      ? `$${estimate.price_low}`
      : `$${estimate.price_low} – $${estimate.price_high}`
    : null;

  return (
    <div style={{
      display: "flex", alignItems: "center", gap: 12, padding: "12px 16px",
      borderRadius: 12, border: `1.5px solid ${isBest ? "#bbf7d0" : "#e5e7eb"}`,
      background: isBest ? "#f0fdf4" : "#fff", marginBottom: 8,
    }}>
      {/* Store icon */}
      <div style={{ width: 38, height: 38, borderRadius: 10, background: store.color, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 15, fontWeight: 900, flexShrink: 0 }}>
        {store.icon}
      </div>

      {/* Store info */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
          <span style={{ fontSize: 14, fontWeight: 700, color: "#111" }}>{store.name}</span>
          {isBest && <span style={{ fontSize: 11, fontWeight: 700, padding: "2px 8px", borderRadius: 20, background: "#dcfce7", color: "#15803d" }}>Best price</span>}
          <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 20, background: `${store.color}15`, color: store.color, fontWeight: 600 }}>{store.badge}</span>
        </div>
        <div style={{ fontSize: 12, color: "#6b7280", marginTop: 2 }}>{store.note}</div>
        {estimate?.note && <div style={{ fontSize: 11, color: "#374151", marginTop: 2 }}>ℹ️ {estimate.note}</div>}
      </div>

      {/* Price + CTA */}
      <div style={{ textAlign: "right", flexShrink: 0 }}>
        {priceStr && (
          <div style={{ fontSize: 16, fontWeight: 800, color: isBest ? "#15803d" : "#111", marginBottom: 4 }}>
            {priceStr}
          </div>
        )}
        {estimate?.oem_price > 0 && estimate?.aftermarket_price > 0 && (
          <div style={{ fontSize: 10, color: "#9ca3af", marginBottom: 4 }}>
            OEM: ${estimate.oem_price} · Aftermarket: ${estimate.aftermarket_price}
          </div>
        )}
        <a href={url} target="_blank" rel="noopener noreferrer"
          style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "6px 12px", borderRadius: 8, background: store.color, color: "#fff", fontSize: 12, fontWeight: 700, textDecoration: "none" }}
          onMouseEnter={e => e.currentTarget.style.opacity = "0.85"}
          onMouseLeave={e => e.currentTarget.style.opacity = "1"}>
          Shop →
        </a>
      </div>
    </div>
  );
}

// ── PARTS ACCORDION ───────────────────────────────────────────────────────────
function PartsAccordion({ onSelect, selectedPart }) {
  const [openIdx, setOpenIdx] = useState(null);
  const toggle = (i) => setOpenIdx(prev => prev === i ? null : i);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      {PARTS_CATEGORIES.map((cat, i) => {
        const isOpen = openIdx === i;
        const hasSelected = cat.parts.includes(selectedPart);
        return (
          <div key={cat.category} style={{ borderRadius: 12, overflow: "hidden", border: `1.5px solid ${hasSelected ? "#2563eb" : isOpen ? "#e2e8f0" : "#e5e7eb"}` }}>
            <button onClick={() => toggle(i)} style={{
              width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between",
              padding: "11px 14px", background: hasSelected ? "#eff6ff" : isOpen ? "#f8fafc" : "#fff",
              border: "none", cursor: "pointer", textAlign: "left",
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontSize: 16 }}>{cat.icon}</span>
                <span style={{ fontSize: 13, fontWeight: 600, color: hasSelected ? "#1d4ed8" : "#374151" }}>{cat.category}</span>
                {hasSelected && <span style={{ fontSize: 11, fontWeight: 700, color: "#1d4ed8", background: "#dbeafe", padding: "1px 8px", borderRadius: 20 }}>{selectedPart}</span>}
              </div>
              <span style={{ fontSize: 12, color: "#9ca3af", fontWeight: 600 }}>{isOpen ? "▲" : "▼"}</span>
            </button>
            {isOpen && (
              <div style={{ padding: "10px 14px 12px", background: "#fafafa", borderTop: "1px solid #f1f5f9", display: "flex", flexWrap: "wrap", gap: 6 }}>
                {cat.parts.map(p => (
                  <button key={p} onClick={() => { onSelect(p); setOpenIdx(null); }}
                    style={{ padding: "6px 14px", borderRadius: 20, border: `1.5px solid ${selectedPart === p ? "#2563eb" : "#e5e7eb"}`, background: selectedPart === p ? "#eff6ff" : "#fff", color: selectedPart === p ? "#1d4ed8" : "#374151", fontSize: 12, fontWeight: selectedPart === p ? 700 : 400, cursor: "pointer" }}>
                    {p}
                  </button>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

// ── MAIN COMPONENT ────────────────────────────────────────────────────────────
export default function PartsSearch() {
  const [year, setYear]           = useState("");
  const [make, setMake]           = useState("");
  const [model, setModel]         = useState("");
  const [selectedPart, setSelectedPart] = useState("");
  const [customPart, setCustomPart]     = useState("");
  const [useCustom, setUseCustom]       = useState(false);

  const [loading, setLoading]     = useState(false);
  const [estimates, setEstimates] = useState(null);
  const [searched, setSearched]   = useState(false);

  const effectivePart = useCustom ? customPart : selectedPart;
  const canSearch = year && make && model && effectivePart;
  const vehicleLabel = year && make && model ? `${year} ${make} ${model}` : null;

  const search = async () => {
    if (!canSearch) return;
    setLoading(true); setEstimates(null); setSearched(false);
    try {
      const data = await estimatePrices(year, make, model, effectivePart);
      setEstimates(data?.estimates || []);
    } catch (e) {
      setEstimates([]);
    } finally {
      setLoading(false);
      setSearched(true);
    }
  };

  // Find best price store
  const bestIdx = estimates?.length > 0
    ? estimates.reduce((bestI, e, i, arr) => e.price_low < arr[bestI].price_low ? i : bestI, 0)
    : -1;

  // Map estimates to stores
  const storeEstimates = {};
  estimates?.forEach(e => { storeEstimates[e.store] = e; });

  return (
    <div style={{ maxWidth: 720, margin: "0 auto", padding: "0 16px 40px", fontFamily: "system-ui, -apple-system, sans-serif" }}>

      {/* Header */}
      <div style={{ marginBottom: 20, padding: "16px 20px", background: "linear-gradient(135deg, #1e3a5f 0%, #0369a1 100%)", borderRadius: 16, color: "#fff" }}>
        <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 4 }}>🔩 Auto Parts Finder</div>
        <div style={{ fontSize: 13, opacity: 0.85 }}>Compare prices across {STORES.length} stores simultaneously — always find the best deal</div>
      </div>

      {/* Vehicle Card */}
      <div style={{ background: "#f8fafc", borderRadius: 12, border: "1.5px solid #e2e8f0", padding: "14px 16px", marginBottom: 16 }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: "#6b7280", marginBottom: 10, textTransform: "uppercase", letterSpacing: 0.5 }}>🚗 Your Vehicle</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
          <div style={fld}>
            <label style={lbl}>Year</label>
            <select value={year} onChange={e => { setYear(e.target.value); setMake(""); setModel(""); }} style={inp}>
              <option value="">Select year</option>
              {VEHICLE_YEARS.map(y => <option key={y} value={y}>{y}</option>)}
            </select>
          </div>
          <div style={fld}>
            <label style={lbl}>Make</label>
            <select value={make} onChange={e => { setMake(e.target.value); setModel(""); }}
              style={{ ...inp, opacity: year ? 1 : 0.5 }} disabled={!year}>
              <option value="">{year ? "Select make" : "Select year first"}</option>
              {VEHICLE_MAKES.map(m => <option key={m} value={m}>{m}</option>)}
            </select>
          </div>
          <div style={fld}>
            <label style={lbl}>Model</label>
            <select value={model} onChange={e => setModel(e.target.value)}
              style={{ ...inp, opacity: make ? 1 : 0.5 }} disabled={!make}>
              <option value="">{make ? "Select model" : "Select make first"}</option>
              {(VEHICLE_DATA[make] || []).map(m => <option key={m} value={m}>{m}</option>)}
            </select>
          </div>
        </div>
      </div>

      {/* Parts Card */}
      <div style={{ background: "#f8fafc", borderRadius: 12, border: "1.5px solid #e2e8f0", padding: "14px 16px", marginBottom: 16 }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: "#6b7280", marginBottom: 10, textTransform: "uppercase", letterSpacing: 0.5 }}>🔩 What Part Do You Need?</div>

        {/* Toggle: browse vs type */}
        <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
          <button onClick={() => setUseCustom(false)} style={{ padding: "6px 14px", borderRadius: 20, border: `1.5px solid ${!useCustom ? "#2563eb" : "#e5e7eb"}`, background: !useCustom ? "#eff6ff" : "#fff", color: !useCustom ? "#1d4ed8" : "#6b7280", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
            Browse categories
          </button>
          <button onClick={() => setUseCustom(true)} style={{ padding: "6px 14px", borderRadius: 20, border: `1.5px solid ${useCustom ? "#2563eb" : "#e5e7eb"}`, background: useCustom ? "#eff6ff" : "#fff", color: useCustom ? "#1d4ed8" : "#6b7280", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
            ✏️ Type part name
          </button>
        </div>

        {!useCustom && (
          <PartsAccordion onSelect={setSelectedPart} selectedPart={selectedPart} />
        )}

        {useCustom && (
          <input value={customPart} onChange={e => setCustomPart(e.target.value)}
            placeholder="e.g. TPMS sensor, radiator hose, alternator..."
            style={inp} />
        )}
      </div>

      <button onClick={search} disabled={!canSearch || loading}
        style={{ width: "100%", padding: 13, borderRadius: 12, border: "none", background: !canSearch ? "#e5e7eb" : loading ? "#93c5fd" : "#0369a1", color: !canSearch ? "#9ca3af" : "#fff", fontSize: 15, fontWeight: 700, cursor: !canSearch || loading ? "not-allowed" : "pointer", marginBottom: 20 }}>
        {loading ? "Finding best prices..." : canSearch ? `Compare prices for ${effectivePart} — ${vehicleLabel}` : "Select vehicle and part to compare"}
      </button>

      {/* Results */}
      {searched && (
        <div>
          {/* Summary bar */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: "#111" }}>
              {effectivePart} for {vehicleLabel}
            </div>
            <div style={{ fontSize: 12, color: "#6b7280" }}>{STORES.length} stores compared</div>
          </div>

          {/* OEM vs Aftermarket tip */}
          <div style={{ padding: "10px 14px", background: "#eff6ff", border: "1.5px solid #bfdbfe", borderRadius: 10, marginBottom: 14, fontSize: 12, color: "#1d4ed8", lineHeight: 1.6 }}>
            💡 <strong>OEM vs Aftermarket:</strong> OEM parts are made by the manufacturer. Quality aftermarket brands (Bosch, Denso, Monroe, ACDelco) match OEM specs at lower cost. Avoid unknown brands for safety-critical parts.
          </div>

          {/* Store rows */}
          {STORES.map((store, i) => {
            const estimate = storeEstimates[store.name];
            const isBest = estimate && bestIdx >= 0 && estimates[bestIdx]?.store === store.name;
            return (
              <StoreRow
                key={store.name}
                store={store}
                year={year}
                make={make}
                model={model}
                part={effectivePart}
                estimate={estimate}
                isBest={isBest}
              />
            );
          })}

          {/* Open all at once button */}
          <div style={{ marginTop: 16, padding: "14px 18px", background: "#1e3a5f", borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
            <div style={{ color: "#fff" }}>
              <div style={{ fontSize: 13, fontWeight: 700 }}>Open all stores at once</div>
              <div style={{ fontSize: 11, opacity: 0.7 }}>Compare prices side by side in separate tabs</div>
            </div>
            <button onClick={() => {
              STORES.forEach((store, i) => {
                setTimeout(() => {
                  window.open(store.buildUrl(year, make, model, effectivePart), '_blank');
                }, i * 300);
              });
            }} style={{ padding: "10px 18px", borderRadius: 10, border: "2px solid rgba(255,255,255,0.3)", background: "rgba(255,255,255,0.15)", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer", flexShrink: 0, whiteSpace: "nowrap" }}>
              Open All {STORES.length} Stores →
            </button>
          </div>

          <div style={{ marginTop: 10, fontSize: 11, color: "#9ca3af", lineHeight: 1.6 }}>
            💡 Prices are AI-estimated ranges. Actual prices may vary. Always verify fitment for your exact vehicle. MioPrice may earn a commission on purchases through Amazon links.
          </div>
        </div>
      )}
    </div>
  );
}
